import { INITIAL_STATE } from './state';
import { forceRemove, handleAddPerson, removePerson, updatePerson, } from './helpers';
export function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case 'PRESENCE/UPDATE_PERSON': {
            return updatePerson(state, action.payload);
        }
        case 'PRESENCE/ADD_PERSON': {
            return handleAddPerson(state, action.payload);
        }
        case 'PRESENCE/REMOVE_PERSON': {
            return removePerson(state, action.payload);
        }
        case 'PRESENCE/FORCE_REMOVE': {
            return forceRemove(state, action.payload);
        }
        case 'PRESENCE/CLEAR': {
            return { ...INITIAL_STATE };
        }
        default:
            return state;
    }
}
